import React, { useReducer, useState } from 'react';
import _ from 'lodash';

import './HotspotWithQuestions.scss'
import Hotspot from './Hotspot';
import ImageCropper from './ImageCropper';
import { ProgressMeter } from './ProgressMeter';
import Scroll from '../../partials/Scroll/Scroll';
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import Button from '../../partials/Button';
import Instructions from "../../partials/Instructions/Instructions";
import Icon from "../../partials/Icons"

const PopupQuestion = ({ data, state, figure, onChoice, onClose }) => {
  
  const headerHtml = { __html: data.questionText };
  const choice =  (state.selectedChoice !== null) ? state.choices[state.selectedChoice] : false
  const feedbackHtml = choice && { __html: choice.feedback };

  return (
    <div className="PopupQuestion centered">
      <div className="scrim"></div>
      <div className="popup-body">
        <div className="hotspot_popup_left">
          <figure>{figure}</figure>
          {choice &&
            <Scroll>
              <div className="fdbck">
                <div dangerouslySetInnerHTML={feedbackHtml} />
              </div>
            </Scroll>
            }
        </div>
        <div className="hotspot_popup_right">
          <Scroll>
            <div className="right-scroll">
              <div className="header" dangerouslySetInnerHTML={headerHtml} />

              <div className="body">
                {state.choices.map((c, i) => {

                    const isChoosed = (i === state.selectedChoice)
                    const isChoiceCorrect = ( isChoosed && c.correct ) 
                    const className = isChoiceCorrect ? 'correct' : ''

                    return <React.Fragment key={i}>
                      <div className={ `test ${className} holder`}>
                        <button className={className} onClick={() => onChoice(i)}>
                            {c.answerText} 
                        </button>
                        {isChoosed && <Icon name={isChoiceCorrect ? 'check' : 'incorrect'} /> }
                      </div>
                    </React.Fragment>
                  }
                )}
              </div>
              <button className="button global-button" onClick={onClose}>CLOSE</button>
            </div>
          </Scroll>
        </div>
      </div>
    </div>
  );
};

const Question = ({ data, state, dispatch, handleNextPage }) => {
  const [openPopupQuestion, setOpenPopupQuestion] = useState(null);
  const [dimensions, setDimensions] = useState({});

  const handleHotspotClick = (i) => {
    dispatch({ type: 'openPopupQuestion', value: i });
    setOpenPopupQuestion(i);
  };

  const handleClose = () => {
    setOpenPopupQuestion(null);
  };

  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;
    const clientWidth = naturalWidth;
    const clientHeight = naturalHeight;
    setDimensions({ clientWidth, clientHeight });
  }

  const handleChoice = (i) => {
    dispatch({ type: 'answerPopupQuestion', value: i });
  };

  // Use absolute URL to keep react/webpack from eating the inline styles
  const imageUrl = new URL(`${data.image}`, window.location.href).toString();

  const popupData = data.popupQuestions[openPopupQuestion];
  //const showingNextButton = state.popupQuestions.length === state.progress.length;
  const showingNextButton = true;

  return (

    <div className="HotspotWithQuestion">
      <div className="Question">
        <div className="sidebar">

          <div className="sidebarContent">
            <Scroll>
              <div className="lineHeight"
                dangerouslySetInnerHTML={{ __html: data.sidebar }} />
            </Scroll>
          </div>

          <ProgressMeter questions={state.popupQuestions}  />

        </div>
        <div className="imageContainer">
          <img className="taskImage" src={imageUrl} onLoad={handleImageLoad} />
          {data.popupQuestions.map((q, i) => {
            return (
              <React.Fragment key={i}>
                <Hotspot key={i}
                  seen={state.popupQuestions[i].seen}
                  correct={state.popupQuestions[i].correct}
                  coordinates={q.coordinates} onClick={() => handleHotspotClick(i)}
                  index={i} />
              </React.Fragment>
            );
          })}
          <div className="hotspot_next_btn_right">
            <Button text="Next" disabled={!showingNextButton} onClick={ handleNextPage } />

          </div>
        </div>

        {(openPopupQuestion !== null) && <PopupQuestion
          figure={
            <ImageCropper imageUrl={imageUrl} coordinates={popupData.coordinates} dimensions={dimensions} />
          }
          data={popupData}
          state={state.popupQuestions[openPopupQuestion]}
          onChoice={handleChoice}
          onClose={handleClose} />}
      </div>

    </div>

  );
};

const HotspotWithQuestions = (props) => {

  console.log(props)

  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'setActiveQuestion': {
          return {
            ...state,
            activeQuestion: action.value

          };
        }
        case 'openPopupQuestion': {
          // Mark it as seen
          const newState = { ...state };
          const activeQuestion = newState.questions[state.activeQuestion];
          activeQuestion.openPopupQuestion = action.value;
          const popupQuestion = activeQuestion.popupQuestions[action.value];
          popupQuestion.seen = true;
          // Prevent carry previous choice.
          popupQuestion.selectedChoice =  null;
          return newState;
        }
        case 'answerPopupQuestion': {
          const newState = { ...state };
          const activeQuestion = newState.questions[state.activeQuestion];

          const popupQuestion = activeQuestion.popupQuestions[activeQuestion.openPopupQuestion];
          if (popupQuestion.selectedChoice !== null) {
            // Bail out
            return state;
          }
          // Locks in the selected choice and pushes to the progress array
          popupQuestion.selectedChoice = action.value;
          const choice = popupQuestion.choices[action.value];
          activeQuestion.progress.push(choice.correct);
          popupQuestion.correct = choice.correct;
          return newState;
        }
        default:
          throw new TypeError(action.type);
      }
    },
    props.data.questions,
    questionData => ({
      questions: questionData.map(question => ({
        // Order in which the answers were selected
        progress: [],
        // Arbitrary order
        popupQuestions: question.popupQuestions.map(popupQuestion => ({
          seen: false,
          correct: null,
          selectedChoice: null,
          // Choices: Array of the entire choices (option text, feedback, correct)
          // Order in which the choices appear
          choices: _.shuffle(popupQuestion.choices)
        })),
        openPopupQuestion: null,
      })),
      activeQuestion: 0,
    })
  );

  // Last unlocked page is the first question whose progress bar isn't full.
  const lastUnlockedPage = findLastUnlockedPage(state);

  const handleNextPage = () => {
    if (state.activeQuestion + 1 < state.questions.length) {
      dispatch({ type: 'setActiveQuestion', value: state.activeQuestion + 1 });
    } else {
      props.onComplete();
    }
  };

  return <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
      <div className="back-btn-container">
        <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
      </div>
      <Instructions body={'Select each icon on the right to explore the concept more deeply.'}></Instructions>
      
      <div className="HotspotWithQuestions">


        <Question key={state.activeQuestion}
          data={props.data.questions[state.activeQuestion]}
          state={state.questions[state.activeQuestion]}
          dispatch={dispatch}
          handleNextPage={handleNextPage} />

      </div>
      </InteractionContainer>
};

const findLastUnlockedPage = (state) => {
  for (let i = 0; i < state.questions.length; i++) {
    const question = state.questions[i];
    if (question.progress.length !== question.popupQuestions.length) {
      return i;
    }
  }
}

export default HotspotWithQuestions;
